module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjYiIHZpZXdCb3g9IjAgMCA4IDYiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiNGMTRBNjE7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNNCwwLDgsNkgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCA2KSByb3RhdGUoMTgwKSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/06sleep/08down.svg
// module id = EwTl
// module chunks = 0